export default __webpack_public_path__ + "static/media/bilinear_pps_10_fov_3000.cf857b42.png";